<div
  data-test="a4xVFqIV"
  (click)="handleToggle()"
  class="view-items view-items_dark"
  [ngSwitch]="type"
>
  <div data-test="eblneVJA" class="view-items__item" [class.active]="leftViewActive">
    <ng-container *ngSwitchCase="'grid'">
      <svg data-test="pSkzGYkP" class="icon__icon-view-grid" width="12px" height="12px">
        <use xlink:href="#icon-view-grid"></use>
      </svg>
    </ng-container>
    <ng-container *ngSwitchCase="'compact'">
      <svg
        data-test="0ZF6siKt"
        class="icon__icon-view-compact"
        width="12px"
        height="12px"
      >
        <use xlink:href="#icon-view-compact"></use>
      </svg>
    </ng-container>
    <ng-container *ngSwitchCase="'compact2'">
      <svg
        data-test="s-dzLPza"
        class="icon__icon-view-compact-2"
        width="12px"
        height="12px"
      >
        <use xlink:href="#icon-view-compact-2"></use>
      </svg>
    </ng-container>
  </div>
  <div data-test="XLABjDHs" class="view-items__item" [class.active]="!leftViewActive">
    <svg data-test="nYWdffc7" class="icon__icon-view-list" width="12px" height="12px">
      <use xlink:href="#icon-view-list"></use>
    </svg>
  </div>
</div>
